export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YOZqik8s6yLUrwB0lw.6e421999.woff2";